var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{class:_vm.error ? 'red--text text--darken-3' : 'grey--text text--darken-3'},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',{class:{'red--text': _vm.error, 'text--darken-3': _vm.error, 'text-h4 text-center':true,  }},[_vm._v(" "+_vm._s(_vm.symbol)+_vm._s(_vm.getValue)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }